import React, { useEffect } from 'react';
import { withTranslate } from 'react-redux-multilingual';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from '@mui/material/IconButton';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import Slide from '@mui/material/Slide';
import Box from '@mui/material/Box';

import {
    IsObject,
} from '../../../libraries/Tool';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function ArrayDialog(props) {

    const { translate, open, onClose, onAgree, scriptsteps, options } = props;
    const [array, setArray] = React.useState([""]);

    const addNewElement = () => {
        let _array = JSON.parse(JSON.stringify(array));
        _array.push("");
        setArray(_array);
    }

    const deleteElement = (i) => {
        if (array.length > 1) {
            let _array = JSON.parse(JSON.stringify(array));
            _array.splice(i, 1);
            setArray(_array);
        }
    }

    useEffect(() => {
        if (options.value && IsObject(options.value) && options.value.toString().search(new RegExp(/\[.*?\]/g)) !== -1) {
            let value = JSON.parse(options.value.toString())?.map((item) => item);
            setArray(value);
        } else {
            setArray([""]);
        }
    }, [options.value])

    return (
        <div>
            <Dialog
                open={open}
                onClose={onClose}
                onAgree={onAgree}
                maxWidth="sm"
                fullWidth
                TransitionComponent={Transition}
            >
                <DialogTitle>{translate('createarray')}</DialogTitle>
                <DialogContent sx={{ display: "grid", maxHeight: "90vh", overflow: "auto" }}>
                    {
                        array.map((item, i) => (
                            <Box sx={{ display: "flex", gap: 1, paddingTop: 2 }}>
                                <Autocomplete
                                    size='small'
                                    freeSolo
                                    key={`array-${i}`}
                                    options={scriptsteps?.filter((step) => step?.output?.icon)?.map(item => item.output.key)}
                                    onChange={(event, newOption) => {
                                        let _array = JSON.parse(JSON.stringify(array));
                                        _array[i] = (newOption) ? newOption : '';
                                        setArray(_array);
                                    }}
                                    getOptionLabel={(option) => option}
                                    fullWidth
                                    value={array[i]}
                                    renderInput={(params) => <TextField {...params} label={`${translate('element')} ${i}`} placeholder='text' onChange={(e) => array[i] = e.target.value} />}
                                />
                                <Tooltip title={translate('deleteelement')} arrow>
                                    <IconButton onClick={() => { deleteElement(i) }}>
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        ))
                    }
                </DialogContent>
                <DialogActions>
                    <Tooltip title={translate('addnewelement')} arrow>
                        <IconButton style={{ position: "absolute", left: 18 }} onClick={addNewElement}>
                            <AddCircleOutlineIcon />
                        </IconButton>
                    </Tooltip>
                    <Button variant="contained" size="small" disableElevation onClick={onClose} color="secondary">
                        {translate('cancel')}
                    </Button>
                    <Button variant="contained" size="small" disableElevation onClick={() => { onAgree(options.index, options.name, array) }} color="primary">
                        {translate('ok')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
export default withTranslate(ArrayDialog);